module.exports = __webpack_public_path__ + "img/arrow_back.3cabf5d5.svg";